import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isLoggedIn", "isFreeTrialEligible", "showSecondaryCTA", "widgetLayoutProps", "onMainCTAClick"];
import React, { forwardRef } from "react";
import { Flex, IconOnePass, Span } from "@catchoftheday/cg-components";
import { UpsellCTAWidgetPrimaryZone, UpsellCTAWidgetZone } from "../../layouts/CTAWidgetLayout/CTAWidgetLayout";
import { UpsellSecondaryCTA } from "../UpsellSecondaryCTA";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellCTAWidget = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isLoggedIn = _ref.isLoggedIn,
      isFreeTrialEligible = _ref.isFreeTrialEligible,
      showSecondaryCTA = _ref.showSecondaryCTA,
      widgetLayoutProps = _ref.widgetLayoutProps,
      onMainCTAClick = _ref.onMainCTAClick,
      secondaryCTAProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(UpsellCTAWidgetZone, _extends({
    ref: ref
  }, widgetLayoutProps), ___EmotionJSX(UpsellCTAWidgetPrimaryZone, {
    onClick: onMainCTAClick,
    "aria-label": isFreeTrialEligible || !isLoggedIn ? "Start free 30 day trial" : "Join OnePass today"
  }, ___EmotionJSX(Flex, {
    alignItems: "center",
    mb: 2
  }, ___EmotionJSX(Span, {
    fontWeight: "bold",
    fontSize: "base",
    whiteSpace: "nowrap"
  }, "Get free delivery with", ___EmotionJSX(IconOnePass, {
    title: "OnePass",
    "aria-label": "OnePass",
    color: "onePass.primary",
    width: "auto",
    height: "1em",
    ml: 1,
    mb: 1
  }))), ___EmotionJSX(Span, {
    fontSize: "xs",
    fontWeight: "medium"
  }, "Join for free delivery on this item and more!", " ", ___EmotionJSX(Span, {
    color: "onePass.primary",
    fontWeight: "bold",
    fontSize: "inherit",
    textDecoration: "underline",
    whiteSpace: "nowrap"
  }, isFreeTrialEligible || !isLoggedIn ? "Start free 30 day trial" : "Join OnePass today"))), showSecondaryCTA && ___EmotionJSX(UpsellSecondaryCTA, _extends({
    tight: true,
    isLoggedIn: isLoggedIn
  }, secondaryCTAProps)));
});
UpsellCTAWidget.displayName = "UpsellCTAWidget";